(function () {
  "use strict";
  // Native forms post to Shopify cart / checkout. No third-party checkout.
  document.documentElement.classList.add("js");
})();

(function () {
  "use strict";
  /* King's Rook lightbox — screenshots only. Header/footer marks stay plain. */

  var WHEEL_MS = 380;
  var SWIPE_PX = 40;
  var overlay;
  var dialogImg;
  var counterEl;
  var closeBtn;
  var prevBtn;
  var nextBtn;
  var group = [];
  var index = 0;
  var lastFocus = null;
  var lastWheel = 0;
  var touchX = 0;

  function qs(root, sel) {
    return root.querySelector(sel);
  }

  function build() {
    overlay = document.createElement("div");
    overlay.className = "lightbox";
    overlay.setAttribute("hidden", "");
    overlay.setAttribute("role", "dialog");
    overlay.setAttribute("aria-modal", "true");
    overlay.setAttribute("aria-label", "Screenshot");
    overlay.innerHTML =
      '<button type="button" class="lightbox__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M5 5l14 14M19 5L5 19" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round"/>' +
        "</svg>" +
      "</button>" +
      '<button type="button" class="lightbox__nav lightbox__prev" aria-label="Previous image">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
      "</button>" +
      '<div class="lightbox__dialog">' +
        '<img class="lightbox__img" alt="">' +
        '<p class="lightbox__counter" aria-live="polite"></p>' +
      "</div>" +
      '<button type="button" class="lightbox__nav lightbox__next" aria-label="Next image">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
          '<path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round"/>' +
        "</svg>" +
      "</button>";
    document.body.appendChild(overlay);
    dialogImg = qs(overlay, ".lightbox__img");
    counterEl = qs(overlay, ".lightbox__counter");
    closeBtn = qs(overlay, ".lightbox__close");
    prevBtn = qs(overlay, ".lightbox__prev");
    nextBtn = qs(overlay, ".lightbox__next");

    closeBtn.addEventListener("click", close);
    prevBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      step(-1);
    });
    nextBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      step(1);
    });
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) close();
    });
    overlay.addEventListener(
      "wheel",
      function (e) {
        if (overlay.hasAttribute("hidden")) return;
        e.preventDefault();
        var now = Date.now();
        if (now - lastWheel < WHEEL_MS) return;
        var dy = e.deltaY;
        var dx = e.deltaX;
        var use = Math.abs(dx) > Math.abs(dy) ? dx : dy;
        if (Math.abs(use) < 8) return;
        lastWheel = now;
        step(use > 0 ? 1 : -1);
      },
      { passive: false }
    );
    overlay.addEventListener(
      "touchstart",
      function (e) {
        if (!e.changedTouches.length) return;
        touchX = e.changedTouches[0].clientX;
      },
      { passive: true }
    );
    overlay.addEventListener(
      "touchend",
      function (e) {
        if (!e.changedTouches.length) return;
        var dx = e.changedTouches[0].clientX - touchX;
        if (Math.abs(dx) < SWIPE_PX) return;
        step(dx < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function collect(fromImg) {
    var start = fromImg.parentElement || fromImg;
    var root = start.closest ? start.closest("[data-lightbox-group]") : null;
    var nodes = root ? root.querySelectorAll(".js-lightbox") : [fromImg];
    var list = [];
    for (var i = 0; i < nodes.length; i++) list.push(nodes[i]);
    if (!list.length) list.push(fromImg);
    return list;
  }

  function srcOf(img) {
    return img.getAttribute("data-lightbox-src") || img.currentSrc || img.src;
  }

  function render() {
    var img = group[index];
    if (!img) return;
    dialogImg.src = srcOf(img);
    dialogImg.alt = img.alt || "";
    counterEl.textContent = group.length > 1 ? index + 1 + " / " + group.length : "";
    var many = group.length > 1;
    prevBtn.hidden = !many;
    nextBtn.hidden = !many;
  }

  function lockScroll(on) {
    document.documentElement.classList.toggle("lightbox-open", on);
    document.body.classList.toggle("lightbox-open", on);
  }

  function openAt(fromImg) {
    group = collect(fromImg);
    index = Math.max(0, group.indexOf(fromImg));
    lastFocus = document.activeElement;
    overlay.removeAttribute("hidden");
    lockScroll(true);
    render();
    closeBtn.focus();
  }

  function close() {
    if (overlay.hasAttribute("hidden")) return;
    overlay.setAttribute("hidden", "");
    dialogImg.removeAttribute("src");
    lockScroll(false);
    if (lastFocus && typeof lastFocus.focus === "function") lastFocus.focus();
  }

  function step(dir) {
    if (group.length < 2) return;
    index = (index + dir + group.length) % group.length;
    render();
  }

  function onKey(e) {
    var open = overlay && !overlay.hasAttribute("hidden");
    if (open) {
      if (e.key === "Escape") {
        e.preventDefault();
        close();
        return;
      }
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        step(-1);
        return;
      }
      if (e.key === "ArrowRight") {
        e.preventDefault();
        step(1);
        return;
      }
      return;
    }
    if (e.key !== "Enter" && e.key !== " ") return;
    var t = e.target;
    if (!t || !t.classList || !t.classList.contains("js-lightbox")) return;
    e.preventDefault();
    openAt(t);
  }

  function onClick(e) {
    var hit = e.target.closest ? e.target.closest(".js-lightbox, .capabilities__hit") : null;
    if (!hit) return;
    var img = hit.classList.contains("js-lightbox") ? hit : hit.querySelector(".js-lightbox");
    if (!img) return;
    e.preventDefault();
    e.stopPropagation();
    openAt(img);
  }

  function init() {
    if (!document.querySelector(".js-lightbox")) return;
    build();
    document.addEventListener("click", onClick);
    document.addEventListener("keydown", onKey);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

(function () {
  "use strict";
  var KIT = { "castle-wall-dual": 1, "castle-wall": 1, "castle-wall-dual-bundle": 1, "castle-wall-bundle": 1 };
  var BUNDLE = { "castle-wall-dual-bundle": 1, "castle-wall-bundle": 1 };
  var ADDON = { "knight": 1, "castle-gate": 1, "annual-support": 1, "castle-wall-mobile": 1 };

  function toast(msg) {
    var el = document.querySelector(".kr-toast");
    if (!el) {
      el = document.createElement("p");
      el.className = "kr-toast";
      el.setAttribute("role", "status");
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.removeAttribute("hidden");
    clearTimeout(toast._t);
    toast._t = setTimeout(function () {
      el.setAttribute("hidden", "");
    }, 4200);
  }

  var EXCLUSIVE = {
    "castle-wall-dual": ["castle-wall-dual-bundle"],
    "castle-wall-dual-bundle": ["castle-wall-dual"],
    "castle-wall": ["castle-wall-bundle"],
    "castle-wall-bundle": ["castle-wall"]
  };

  function hasKit(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (KIT[items[i].handle]) return true;
    }
    return false;
  }

  function hasBundle(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (BUNDLE[items[i].handle]) return true;
    }
    return false;
  }

  function keysFor(cart, pred) {
    var keys = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (pred(items[i].handle)) keys.push(items[i].key);
    }
    return keys;
  }

  function addonKeys(cart) {
    return keysFor(cart, function (h) { return ADDON[h]; });
  }

  function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) {
      return r.json();
    });
  }

  function zeroKeys(keys) {
    if (!keys.length) return Promise.resolve(false);
    var updates = {};
    for (var i = 0; i < keys.length; i++) updates[keys[i]] = 0;
    return fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ updates: updates })
    }).then(function (r) {
      return r.json();
    }).then(function () {
      return true;
    });
  }

  function stripAddons(cart) {
    return zeroKeys(addonKeys(cart));
  }

  var MOBILE = "castle-wall-mobile";

  // A bundle already carries Knight, Castle Gate and Support; Mobile is a separate term SKU, so it
  // stays in the cart when a bundle is added and may be added alongside a bundle.
  function bundledAddonKeys(cart) {
    return keysFor(cart, function (h) { return ADDON[h] && h !== MOBILE; });
  }

  function mobileKeys(cart) {
    return keysFor(cart, function (h) { return h === MOBILE; });
  }

  function formVariantId(form) {
    var input = form.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : 0;
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); });
  }

  function exclusiveKeys(cart, handle) {
    var drop = EXCLUSIVE[handle] || [];
    var set = {};
    for (var i = 0; i < drop.length; i++) set[drop[i]] = 1;
    return keysFor(cart, function (h) { return set[h]; });
  }

  function destackPairs(cart) {
    var items = (cart && cart.items) || [];
    var by = {};
    for (var i = 0; i < items.length; i++) by[items[i].handle] = items[i].key;
    var drop = [];
    if (by["castle-wall-dual"] && by["castle-wall-dual-bundle"]) drop.push(by["castle-wall-dual"]);
    if (by["castle-wall"] && by["castle-wall-bundle"]) drop.push(by["castle-wall"]);
    return zeroKeys(drop);
  }

  function passSubmit(form) {
    form.setAttribute("data-kr-pass", "1");
    HTMLFormElement.prototype.submit.call(form);
  }

  document.addEventListener(
    "submit",
    function (e) {
      var form = e.target;
      if (!form || form.nodeName !== "FORM") return;
      if (form.getAttribute("data-kr-pass") === "1") return;
      var action = form.getAttribute("action") || "";
      var role = form.getAttribute("data-cart-role") || "";
      var handle = form.getAttribute("data-product-handle") || "";
      var isAdd = action.indexOf("/cart/add") !== -1;
      if (!isAdd) return;

      if (role === "addon" || ADDON[handle]) {
        e.preventDefault();
        getCart().then(function (cart) {
          if (hasBundle(cart) && handle !== MOBILE) {
            toast("This bundle already includes Knight, Castle Gate, and Annual Support.");
            return;
          }
          if (hasKit(cart) && handle === MOBILE) {
            // One Mobile plan at a time: choosing Monthly replaces Yearly and vice versa.
            var id = formVariantId(form);
            return zeroKeys(mobileKeys(cart)).then(function () {
              return addItems([{ id: id, quantity: 1 }]);
            }).then(function () {
              if (window.krTrack) window.krTrack("addon_mobile", { handle: handle, plan: form.getAttribute("data-kr-plan") || "" });
              window.location.href = "/cart";
            });
          }
          if (hasKit(cart)) {
            passSubmit(form);
          } else {
            toast("Pick a Castle Wall first. Add-ons need a box to run on.");
            if (window.krTrack) window.krTrack("addon_without_kit", { handle: handle });
            var kits = document.querySelector("#kits") || document.querySelector('a[href*="#kits"]');
            if (kits && kits.scrollIntoView) kits.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
        return;
      }

      if (role === "kit" || KIT[handle]) {
        e.preventDefault();
        getCart().then(function (cart) {
          var drop = exclusiveKeys(cart, handle);
          if (BUNDLE[handle]) drop = drop.concat(bundledAddonKeys(cart));
          var seen = {};
          var uniq = [];
          for (var i = 0; i < drop.length; i++) {
            if (seen[drop[i]]) continue;
            seen[drop[i]] = 1;
            uniq.push(drop[i]);
          }
          return zeroKeys(uniq).then(function () {
            var mobile = window.KR_MOBILE || {};
            if (BUNDLE[handle] && mobile.forSale && mobile.yearly && !mobileKeys(cart).length) {
              // "+ add-ons" means every add-on: the bundle SKU plus a year of Mobile as its own line
              // (the cloud mints Mobile from its SKU, so it cannot be folded into the bundle price).
              var items = [{ id: formVariantId(form), quantity: 1 }, { id: mobile.yearly, quantity: 1 }];
              return addItems(items).then(function () {
                window.location.href = "/cart";
              });
            }
            passSubmit(form);
          });
        });
      }
    },
    true
  );

  // A box's console links to the shop with ?box=<entitlement id> (also inside the #kits hash). Remember it and
  // stamp it on the cart as attributes[kings_rook_entitlement] so the cloud attaches the add-on to that box.
  var BOX_KEY = "kr_box";
  function boxFromUrl() {
    var m = (location.search + " " + location.hash).match(/[?&]box=(ent_[A-Za-z0-9]+)/);
    return m ? m[1] : "";
  }
  function rememberBox() {
    var b = boxFromUrl();
    try { if (b) localStorage.setItem(BOX_KEY, b); return b || localStorage.getItem(BOX_KEY) || ""; } catch (_) { return b; }
  }
  var krBox = rememberBox();
  if (krBox) {
    var attrInput = document.querySelector("[data-kr-box-attr]");
    if (attrInput && !attrInput.value) attrInput.value = krBox;
    getCart().then(function (cart) {
      if (cart && cart.attributes && cart.attributes.kings_rook_entitlement === krBox) return;
      return fetch("/cart/update.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ attributes: { kings_rook_entitlement: krBox } }) });
    }).catch(function () {});
  }

  var page = document.querySelector("[data-cart-page]");
  if (page) {
    getCart().then(function (cart) {
      return destackPairs(cart).then(function (didPair) {
        if (!hasKit(cart)) {
          return stripAddons(cart).then(function (didAddons) {
            if (didPair || didAddons) window.location.reload();
          });
        }
        if (didPair) window.location.reload();
      });
    });
  }
})();

(function () {
  "use strict";
  var btn = document.querySelector(".back-top");
  var sticky = document.querySelector(".sticky-cta");
  if (!btn && !sticky) return;
  function scrolled() {
    return window.scrollY || document.documentElement.scrollTop || 0;
  }
  function atTop() {
    return scrolled() < 64;
  }
  function hide() {
    if (btn) btn.classList.remove("is-visible");
  }
  function kitsInView() {
    var kits = document.querySelector("#kits, #buy, .cart-page");
    if (!kits) return false;
    var r = kits.getBoundingClientRect();
    return r.top < window.innerHeight * 0.6 && r.bottom > 0;
  }
  function sync() {
    if (btn) {
      if (atTop()) hide();
      else btn.classList.add("is-visible");
    }
    if (sticky) {
      var show = scrolled() > 520 && !kitsInView();
      sticky.classList.toggle("is-visible", show);
    }
  }
  window.addEventListener("scroll", sync, { passive: true });
  sync();
  if (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }
})();

(function () {
  "use strict";
  /* Measurement. Named funnel events (review §5): cta_hero, cta_sticky, view_pricing,
     add_kit, addon_castle_gate, addon_mobile, addon_knight, addon_support, addon_without_kit,
     faq_open, lead_capture, contact_submit, checkout_start. Each is published to Shopify's
     custom-pixel bus (Shopify.analytics.publish → a Custom Pixel subscribed to the name must be
     created once in Settings → Customer events) and pushed to window.dataLayer for GA4/GTM. */
  function publish(name, payload) {
    var data = payload || {};
    data.page = window.location.pathname;
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === "function") {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (e) { /* analytics must never break the store */ }
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, kr: data });
    } catch (e) { /* ignore */ }
  }
  window.krTrack = publish;

  function payloadOf(el) {
    var p = {};
    if (el.getAttribute("data-kr-place")) p.place = el.getAttribute("data-kr-place");
    if (el.getAttribute("data-kr-kit")) p.kit = el.getAttribute("data-kr-kit");
    if (el.getAttribute("data-product-handle")) p.handle = el.getAttribute("data-product-handle");
    var href = el.getAttribute("href");
    if (href) p.href = href;
    return p;
  }

  document.addEventListener("click", function (e) {
    var el = e.target.closest ? e.target.closest("[data-kr-event]") : null;
    if (!el || el.nodeName === "FORM") return;
    publish(el.getAttribute("data-kr-event"), payloadOf(el));
  });

  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!form || form.nodeName !== "FORM") return;
    var name = form.getAttribute("data-kr-event");
    if (name) publish(name, payloadOf(form));
    var btn = document.activeElement;
    if (btn && btn.getAttribute && btn.getAttribute("data-kr-event") && btn.form === form && btn.name === "checkout") {
      publish(btn.getAttribute("data-kr-event"), { place: "cart" });
    }
  }, true);

  document.addEventListener("toggle", function (e) {
    var d = e.target;
    if (!d || !d.classList || !d.classList.contains("faq__item") || !d.open) return;
    var q = d.getAttribute("data-kr-faq") || (d.querySelector("summary") || {}).textContent || "";
    publish("faq_open", { question: String(q).trim().slice(0, 80) });
  }, true);

  var seen = {};
  var targets = document.querySelectorAll("[data-kr-view]");
  if (targets.length && "IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var name = en.target.getAttribute("data-kr-view");
        if (seen[name]) return;
        seen[name] = 1;
        publish(name, { id: en.target.id || "" });
      });
    }, { threshold: 0.35 });
    for (var i = 0; i < targets.length; i++) io.observe(targets[i]);
  }
})();
